<template>
  <div class="notice-new-list-box">
      <div class="fack" style="margin-top: 20px;">
        <div class="notice-new-title" style="padding: 0">
        <!-- <div @click="goto" style="flex:1; text-align: right;font-size:12px;padding-right:8px">
        信息中心 <img src="../../../assets/images/icon_1@2x.png" alt="">
        </div> -->
      </div>
      <img class="txt-img" src=".././../../assets/images/hr@2x.png" />
     <!-- <van-sticky > -->
      <div class="tabs-box">
            <van-tabs  class="tab_1" title-active-color="#000000;"   background="linear-gradient(180deg, #FFF4E0 0%, #FBCB89 100%) "  @click-tab="changeTabs" v-model:active="activeTabs">
              <van-tab  v-for="(item, index) in tabs" :key="item" :title='item.title' :name="item.id">
              </van-tab>
            </van-tabs>
      </div>
    <!-- </van-sticky> -->
        <div class="match-container-search" >
          <input type="text" style="" placeholder="请输入政策词条" v-model="searchStr1" @focus="handleInput"  />
          <div class="btn" @click="goSearchV2">
            <img src="@/assets/images/vector@2x.png" alt="">
            <span style="margin-right:4px;margin-left:4px">|</span>
            <span>搜索</span>
          </div>
        </div>
      <div class="serch" style="padding-top: 10px;padding-right:12px">  
          
          <div style="display:flex;justify-content: space-evenly;flex:1">
            <div class="flex-item" style="display:flex">
              <div class="serch-text">筛选：</div>
              <span class="serch-item" :class="{'serch-item-active':show3}" @click="showPopup0">{{topchange0}}</span>
              <img style="height:6px;width:10px;margin-bottom: 1px;margin-top:5px" src="../../..//assets/images/Vector@2x_1.png" alt="">
            </div>
            <div class="flex-item" style="display:flex">
              <span class="serch-item" :class="{'serch-item-active':show3}" @click="showPopup3">{{topchange1}}</span>
              <img style="height:6px;width:10px;margin-bottom: 1px;margin-top:5px" src="../../..//assets/images/Vector@2x_1.png" alt="">
              </div>
              <div class="flex-item" style="display:flex">
                <span class="serch-item" :class="{'serch-item-active':show2}" @click="showPopup2">{{topchange2}}</span>
                <img style="height:6px;width:10px;margin-bottom: 1px;margin-top:5px" src="../../..//assets/images/Vector@2x_1.png" alt="">
              </div> 
              <div class="flex-item" style="display:flex">
                <span class="serch-item" :class="{'serch-item-active':show2}" @click="showPopup1">{{topchange3}}</span>
                <img style="height:6px;width:10px;margin-bottom: 1px;margin-top:5px" src="../../..//assets/images/Vector@2x_1.png" alt="">
              </div>
          </div>
        </div>
        <van-popup v-model:show="show3" round position="bottom"  >
          <div class="boxs">
                  <p class='title'>请选择发文部门</p>
                  <div style="height: 200px; overflow: auto">
                    <div class="field-ul">
                      <div  class="flex-tag-select-container" style="grid-template-columns: 1fr 1fr;">
                          <div v-for="(item, i) in fieldList" :key=" i" class="flex-tag-select-item"
                              :class="{ 'selected': item.checked }" @click="() => toggleItem(item, item.leve)">
                              {{ item.dispatch_name }}
                          </div>
                      </div>
                  </div>
                  </div>
                   <div style="margin: 22px 55px;text-align:center;">
                      <van-button  @click="roundbtn2" class="roundbtn" round type="primary" >确定</van-button>
                    </div>
          </div>
      </van-popup>
      <van-popup v-model:show="show4" round position="bottom"  >
          <div class="boxs" >
                  <p class='title'>请选择行政级别</p>
                  <div style="height: auto">
                    <div class="field-ul">
                      <div  class="flex-tag-select-container">
                          <div v-for="(item, i) in public1" :key="i" class="flex-tag-select-item"
                              :class="{ 'selected': item.checked }" @click="() => toggleItem2(item, item.leve)">
                              {{ item.name }}
                          </div>
                      </div>
                  </div>
                  </div>
                   <div style="margin: 22px 55px;text-align:center;">
                  <van-button  @click="roundbtn1" class="roundbtn" round type="primary">确定</van-button>
                  </div>
          </div>
      </van-popup>
      <van-popup v-model:show="show0" round position="bottom"  >
          <div class="boxs" >
                  <p class='title'>请选择行政区域</p>
                  <div style="height: auto">
                    <div class="field-ul">
                      <div  class="flex-tag-select-container">
                          <div v-for="(item, i) in public0" :key="i" class="flex-tag-select-item"
                              :class="{ 'selected': item.checked }" @click="() => toggleItem0(item)">
                              {{ item.name }}
                          </div>
                      </div>
                  </div>
                  </div>
                   <div style="margin: 22px 55px;text-align:center;">
                  <van-button  @click="roundbtn0" class="roundbtn" round type="primary">确定</van-button>
                  </div>
          </div>
      </van-popup>
      <van-popup v-model:show="show5" round  >
          <div class="boxs" style="width:auto;height:auto;padding-bottom:10px;min-width:300px">
                  <p class='title  box-title' >请选择发文时间</p>
                  <Dates v-model="formSearch.start_time" name='发文开始时间' label='发文开始时间' placeholder='选择发文开始时间' :key="codeNum"></Dates>
                   <Dates v-model="formSearch.end_time" name='发文结束时间' label='发文结束时间' placeholder='选择发文结束时间' :key="codeNum"></Dates>
            <div style="text-align:center;margin-top:20px">
            <van-button class="show5btn" type="primary" round @click="changetime">确认</van-button>
            </div>
          </div>
      </van-popup>
      <!-- <van-popup v-model:show="show5" round v-else  >
          <div class="boxs" style="width:340px;height:313px">
                  <p class='title'>请选择发文时间</p>
                  <Dates v-model="formSearch.start_time" name='发文开始时间' label='发文开始时间' placeholder='选择发文开始时间' :key="codeNum"></Dates>
                   <Dates v-model="formSearch.end_time" name='发文结束时间' label='发文结束时间' placeholder='选择发文结束时间' :key="codeNum"></Dates>
            <div style="text-align:center;margin-top:20px">
            <van-button class="show5btn" type="primary" round @click="changetime">确认</van-button>
            </div>
          </div>
      </van-popup> -->
      </div> 
    <van-empty description="~暂无相关信息~"  :image="require('@/assets/images/match/icon_7@2x.svg')" v-show="emptyShow" />
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getData"
      ref="shou"
      v-if="!emptyShow"
      style="margin: 10px"
      class="list-box"
    >
    <div
      class="notice-item"
      v-for="(record, index) in list"
      :key="record"
      @click.stop="goDetail(record)"
      
    >
      <div class="notice-item-content">
         <!-- <div :class="{ 'notice-item-novip': (!isVip || !certificationFlag) && index == list.length - 1 }"> -->
         <div>
            <div class="notice-item-title">
             <span class="level" v-if="record.level && record.level > 3"
                  >其他</span
                >
                <span
                  class="level"
                  v-else-if="record.level && record.level == 1"
                  >省</span
                >
                <span
                  class="level"
                  v-else-if="record.level && record.level == 2"
                  >市</span
                >
                <span
                  class="level"
                  v-else-if="record.level && record.level == 3"
                  >区县</span
                >
                <span class="level" v-else>国</span>
            {{ record.title }}
            </div>
            <div class="policy-content" v-if="record.description">
            <div>{{ record.description }}</div>
            </div>
        </div>
        <!-- <div class="novip-box" v-if="!certificationFlag && index == list.length - 1">
            <div class="flex-item">
                <div>您有超过{{page.total}}条数据 关联企业信息后查看</div>
                <van-button class="btn" @click.stop="goMore">立即关联</van-button>
            </div>
        </div>
        <div class="novip-box" v-if="certificationFlag && !isVip && index == list.length - 1">
            <div class="flex-item">
                <div>还有{{page.total}}条数据 获取VIP后可查看</div>
                <van-button class="btn" @click.stop="goVip">立即获取</van-button>
            </div>
        </div> -->
      </div>
      <div class="notice-item-footer">
        <div class="flex-item" style="flex: 1">
          <div class="flex">
            <div class="policy-file-item-tags flex-item">
              <van-tag class="tag tag_0" style="margin-right:4px;background: #D8F4F0;border-radius: 4px 4px 4px 4px;color: #000000;">
            {{ record.dispatch_name }}
          </van-tag>
            </div>
            <div class="flex-item" style="margin-left: -10px;white-space: nowrap;">
              发布时间:{{ record.prepareDate }}
            </div>
          </div>
          <div class="flex">
            <div class="flex-item" v-if="activeTabs == 'all'">
              <van-tag class="tag tag_1" v-if="record.type==0" >
                其他政策
              </van-tag>
              <van-tag class="tag tag_1" v-if="record.type==1" >
                申报通知
              </van-tag>
              <van-tag class="tag tag_1" v-if="record.type==2" >
                立项公示
              </van-tag>
            </div>
            <div class="flex-item" v-else-if="typename == '1' && record.declare_type != null">
              <van-tag class="tag tag_1" v-if="record.declare_type==0" >
                资金申报
              </van-tag>
              <van-tag class="tag tag_1" v-if="record.declare_type==1" >
                资质办理
              </van-tag>
            </div>
            <div class="flex-item">阅读量:{{ record.click_num }}</div>
            <div class="flex-item">
              收藏量:{{ record.favorite_num }}
            </div>
          </div>
        </div>
        <!-- <div class="btn-boxs" v-if="!isVip && index == list.length - 1">
            <div class="btn-favorite btn-favorite-dis" @click.stop="">
                <img
                class="icon-favorite"
                src="@/assets/images/icon_favorite_1@2x.png"
                />
                收藏
            </div> 
        </div> -->
        <div class="btn-boxs">
          <van-button
            class="btn-favorite"
            v-if="!record.favorite"
            @click.stop="doFav(record,true)"
          >
            <img
              class="icon-favorite"
              src="@/assets/images/icon_favorite_1@2x.png"
            />
            收藏
          </van-button>
          <van-button
            class="btn-favorite btn-favorite-active"
            v-else
            @click.stop="doFav(record,false)"
          >
            <img
              class="icon-favorite"
              src="@/assets/images/icon_favorite_2@2x.png"
            />
            已收藏
          </van-button>
        </div>
      </div>
    </div>
</van-list>

  </div>
</template>
<script>
import { queryArticleSearch,getDispatchlevel, getDispatchv3,dispatchDepartmentGetAll, getServiceProviderList, queryUserById ,getInformation,addFavoritev3,cancelFavoritev3} from '@/api/home'
import store from '@/store';
import { clickUrl } from "@/utils";
import moment from 'moment'
import Dates from '@/components/Date.vue'
import { Toast } from 'vant';
export default {
  name: "Match",
    components: { Dates },
  props: {
    searchStr: {
      
    },
    isVip: {
      type: Boolean,
      default: false,
      },
      loading: {
        type: Boolean,
        default: false,

    },
       certificationFlag:{
        type: Number,
        default: 0,
    },
    total: {
        type: Number,
        default: 0,
    },
  },
  data() {
      return {
        loading: false,
      recordtype:true,
      topchange0:'行政区域',
      topchange1:'行政级别',
      topchange2:'发文部门',
      topchange3:'发文时间',
      // formSearch: {
      //   daterange: [],
      //   dispatchDepartment: '',
      //   start_time: null,
      //   end_time: null,
      //   searchContent: ''
      // },
       tabss: [
        { title: "政策口径", id: '1' },
        { title: "行政级别", id: '2' },
      ],
        tabs: [
        { title: "全部", id: 'all' },
        { title: "申报通知", id: 'declare' },
        { title: "立项公示", id: 'policy' },
        { title: "其他政策", id: 'notify' },
      ],
      public1:[
        { id:'0', name: '国',value: '',checked: false },
          { id:'1', name: '省',value: '',checked: false },
          { id:'2', name: '市',value: '',checked: false },
          { id:'3', name: '区县',value: '',checked: false },
      ],
      public0:[
        { id:'2697', name: '四川',value: '',checked: false },
        { id:'2656', name: '重庆',value: '',checked: false },
      ],
      searchTpt: [
        {
          type: 'select', label: "发文部门", placeholder: "请选择发文部门", form: "dispatchDepartment", optionName: "name", optionValue: "id", name: "dispatchDepartment", options: []
        },
        // {
        //   type: 'select', label: "发文类别", placeholder: "请选择发文类别", form: "proj_id", table: "proj", tableForm: {},
        //   optionName: "name", optionValue: "id", name: "proj_name",options:[]
        // },
      ],
      formSearch: {
        start_time: null,
        end_time: null,
      },
      list:[],
      clickSearch: false,
      // loading: false,
      finished: false,
      emptyShow: false,
      codeNum: null,
      declareShow: false,
      declareList: [],
      company: {},
      page:{
        count: 0,
        size: 20,
        total: 0
      },
      departmentList: [],
      showPicker: false,
      title:'',
      show0:false,
      show1:false,
      show2:false,
       show3:false,
      show4:false,
      show5:false,
      fieldList: [
                { id:'1', name: '发改',value: '',checked: false },
                { id:'2', name: '经信',value: '',checked: false },
                { id:'3', name: '科技',value: '',checked: false },
                { id:'4', name: '综合办',value: '',checked: false },
                { id:'5', name: '综合办',value: '',checked: false },
                { id:'6', name: '科技',value: '',checked: false },
                { id:'7', name: '经信',value: '',checked: false },
                { id:'8', name: '发改',value: '',checked: false },
                
            ],
            type:'',
            dispatch_name:'',
           record:{} ,
            favFlag: false,
            refs:"", 
            typename:'',
        searchStr1: '',
            activeTabs: "all",
            start_time:null,
            end_time:null,
            province_name :'四川',
            areaname:'',
            levelname:'',
            area_id:null,
            level:null,
            textpick:true

    }
  },
  mounted() {
    this.getDispatchlevel()
  },
  methods: {
      moment,
     async getDispatchlevel(){
      let params={}
      if(this.province_name!=''){
        params.province_name=this.province_name
      }
      try{
        let res = await getDispatchlevel(params)
        console.log(res);
        this.public1=res.result
      }catch{}
      },
      goSearchV2() {
        this.page.count = 0
        this.list = []
        this.start_time=null
      this.end_time=null
        this.getData()
      console.log(this.searchStr1);
    },
     timestampToTime(timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
       var  D = (date.getDate()<10 ? '0'+date.getDate() :date.getDate()) + ' ';
       var h = date.getHours() + ':';
       var  m = date.getMinutes() + ':';
       var  s = date.getSeconds();
        return Y+M+D+h+m+s;
    },
    changetime(){
      console.log(this.formSearch.start_time);
      console.log(this.end_time);
      this.start_time=this.timestampToTime(this.formSearch.start_time).slice(0,10)
      this.end_time=this.timestampToTime(this.formSearch.end_time).slice(0,10)
      if(this.formSearch.start_time>this.formSearch.end_time || !this.formSearch.start_time || !this.formSearch.end_time){
      this.start_time=null
      this.end_time=null
      console.log(this.formSearch.start_time);
          Toast('请选择正确的时间');
      }else{
        this.list=[]
        this.topchange3=this.start_time.slice(5,10)+'-'+this.end_time.slice(5,10)
        this.page.count=0
        this.getData()
        this.show5=false
      }
    },
      showPopup2(){
        // this.show3 = !this.show3
        if(this.textpick){
          var that = this
          this.getbumen(function () {
            that.show3 = true
          })
        }else{
           Toast('暂无发文部门');
        }
    },
    showPopup3(){
      this.show4 = !this.show4
    },
    showPopup1(){
      // this.start_time=
      console.log(this.formSearch.start_time);
      console.log(this.formSearch.end_time);
      this.show5 = !this.show5
    },
    showPopup0(){
      this.show0 = !this.show0
    },
      roundbtn2(){
        this.topchange3='发文时间'
        this.start_time=null
      this.end_time=null
      // this.formSearch.start_time=null
      // this.formSearch.end_time=null
        this.show3=false
        this.page.count = 0
        this.list = []
       if (this.dispatch_name!='') {
         this.topchange2=this.dispatch_name
         console.log(1);
      }else{
        this.topchange2='发文部门'
      }
        console.log(this.dispatch_name);
        this.getData()
      },
    roundbtn1() {
      console.log(this.area_id);
      // this.area_id=null
      this.topchange3='发文时间'
      this.topchange2='发文部门'
       this.start_time=null
      this.end_time=null
      // this.formSearch.start_time=null
      // this.formSearch.end_time=null
      console.log(this.formSearch.end_time);
        this.formSearch.dispatch_name = ''
        this.dispatch_name = ''
        this.show4=false
      this.page.count = 0
         this.list = []
         console.log(this.level);
         if(this.levelname!=''){
            this.topchange1=this.levelname
         }else{
        this.topchange1='行政级别'
         }
         if(this.level==0.1){
          this.level=0
          // this.area_id=null
          this.textpick=true
         }else if(this.level==0.2){
          this.level=1
          // this.area_id=null
          this.textpick=true
         }else if(this.level==0.3){
            this.level=2
            // this.area_id=null
            this.textpick=true
         }else if(this.level==0.4){
            this.level=3
            // this.area_id=null
            this.textpick=true
         }else if(this.level>100){
            this.area_id=this.level
            this.level=null
            this.textpick=false
         }
           console.log(this.level);
        this.getData()

      },
      roundbtn0(){
          this.topchange1='行政级别'
          this.topchange3='发文时间'
          this.topchange2='发文部门'
          this.start_time=null
          this.end_time=null
          this.formSearch.dispatch_name = ''
          this.dispatch_name = ''
          this.show0=false
          this.page.count = 0
          this.list = []
          this.level = null
          this.public1 = this.public1.map((item) => {
              return {
                  ...item,
                  checked: false,
              };
          })
          this.textpick = true
          if(this.areaname != ''){
              this.topchange0 = this.areaname
          } else {
              this.topchange0 = '行政区域'
          }
          this.getData()
      },
      toggleItem(val) {
        console.log(val);
        this.fieldList = this.fieldList.map((item) => {
        return {
          ...item,
              checked: item.dispatch_name == val.dispatch_name ? !item.checked : false,
            };
          });
          if(val.checked){
          this.dispatch_name=''
          }else{
            this.dispatch_name=val.dispatch_name
          }
        },
      toggleItem2(val) {
       this.public1 = this.public1.map((item) => {
        return {
          ...item,
          checked: item.id == val.id ? !item.checked : false,
        };
      });
      if(val.checked){
        this.area_id=null
          this.level=null
          this.levelname=''
          }else{
            this.level= val.id
            this.levelname=val.name
          }
          console.log(this.level);
        },
      toggleItem0(val) {
          this.public0 = this.public0.map((item) => {
              return {
                  ...item,
                  checked: item.id == val.id ? !item.checked : false,
              };
          });
          if (val.checked) {
              this.area_id = ''
              this.areaname = ''
              this.province_name = ''
          } else {
              this.area_id = val.id
              this.areaname = val.name
              this.province_name = val.name
          }
      },
    async getbumen(callback) {
      console.log(this.activeTabs,this.level);
      let params = {}
      if (this.level>=0) {
        params.level = this.level
      }
      console.log(this.level);
      if (this.activeTabs == "declare") {
        params.type = 1
      } else if (this.activeTabs == "policy") {
        params.type = 2
      } else if (this.activeTabs == "notify") {
        params.type = 0
      }

      try {
        let res = await getDispatchv3(params);
        console.log(res);
        let dispatch_name = this.dispatch_name
        this.fieldList = res.result.filter(o => o.dispatch_name).map(item => {
          return {
            ...item,
            checked:
            item.dispatch_name == dispatch_name ? !item.checked : false,
          }
        });
        if (callback) {
          callback()
        }
      } catch {

      }
    },
      init() {
      if (this.$route.query.userInfo) {
        this.userInfo = JSON.parse(this.$route.query.userInfo)
        setToken(this.userInfo.token)
        setUserInfo(this.userInfo)
      }
      this.codeNum = new Date().getTime()
      this.getdispatchDepartment()
      this.getDeclareList()
    },
    handle() {
      this.clickSearch = !this.clickSearch
    },
    changeTabs(val) {
      this.area_id=null
      console.log(val.name);
       this.typename = ''
      if(val.name=='declare'){
        this.typename=1
      }else if (val.name=='policy'){
        this.typename=2
      }else if (val.name=='notify'){
        this.typename=0
      }
       this.start_time=null
      this.end_time=null
      // this.formSearch.start_time=null
      // this.formSearch.end_time=null
      this.topchange0='行政区域'
      this.topchange1='行政级别'
      this.topchange2='发文部门'
      this.topchange3='发文时间'
      this.dispatch_name=''
      this.level=''
      this.searchStr1=''
      this.activeTabs = val.name
      this.reset()
      this.getData()
    },
    reset() {
      this.formSearch = {
         searchContent: "",
          dispatch_name: "",
          level: "",
      }
      this.searchStr1 = ''
      this.dispatch_name = ''
      this.level = ''
      this.public1 = this.public1.map((item) => {
        return {
          ...item,
          checked: false,
        };
      });
      this.public0 = this.public0.map((item) => {
        return {
          ...item,
          checked: false,
        };
      });
      this.fieldList = []
      this.clickSearch = false
      this.codeNum = new Date().getTime()
      this.list = []
      this.page.count = 0
    },

    onSubmit() {
      this.page.count = 0
      this.list = []
      this.getData()
    },

    async getData() {
      console.log(this.level);
      console.log(this.searchStr);
      var that = this
      this.page.count += 1
      this.loading = true
      let {  searchContent, dispatch_name, level } = this.formSearch
      console.log(this.dispatch_name);
      let params = {
        page: this.page.count,
        pageSize: this.page.size,
      };
      if(this.area_id){
          params.area_id=this.area_id
      }
      if(this.activeTabs=='policy'){
        this.type = 2
        params.type = 2
      }else if (this.activeTabs=='declare'){
        this.type = 1
        params.type = 1
      }else if(this.activeTabs=='notify'){
        this.type = 0
        params.type = 0
      }
 if(this.start_time){
        params.start_time=this.start_time
      }
       if (this.end_time){
        params.end_time=this.end_time
      }
      if (this.dispatch_name) {
        console.log(1);
        params.dispatch_name = this.dispatch_name;
      }
      if (this.level>=0) {
        console.log(this.level,'000000');
        params.level = this.level;
      }
      if (this.searchStr1) {
        params.keywords = this.searchStr1;
      }
      try{
      let res = await getInformation(params)
      console.log(res);
        let list = res.result.data.map(item => {
          item.statusView = -1
          let nowTime = new Date().getTime()
            let startTime = item.start_time ? moment(item.start_time).toDate().getTime() : ''
            let endTime = item.end_time ? moment(item.end_time).toDate().getTime() : ''
            if (endTime && nowTime >= endTime) {
              item.statusView = 0
            } else if (startTime && nowTime < startTime) {
              item.statusView = 2
            } else if (startTime && nowTime >= startTime) {
              item.statusView = 1
            }

        return {
          ...item,
          content: item.description ? that.getText(item.description) : '',
          prepareDate: item.time ? moment(item.time).format("YYYY-MM-DD") : '',
          releaseDate: item.create_time ? moment(item.create_time).format("YYYY-MM-DD") : '',
          statusView: item.statusView
        }
      }) || []
      let list_new = list
      //  if (!this.isVip) {
      //     list_new = list.slice(0,2)
      //   }

      //   if (!this.certificationFlag) {
      //     list_new = list.slice(0,1)
      //   }
      console.log(this.list);
        this.list = this.list.concat(list_new)
      console.log(this.list);
      this.page.total = res.result.total||0
      this.finished = this.list.length >= res.result.total && res.result.total != 0 ? true : false
      this.emptyShow = !res.result.total ? true : false
      }catch{
        this.page.total = 0
        this.finished = true
      }finally{
        this.loading = false
      }
      if(this.activeTabs == 'declare' ){
          this.title = '政策申报'
      }else if (this.activeTabs == 'policy'){
          this.title = '政策文件'
      }else if (this.activeTabs == 'notify'){
          this.title = '通知/公告'
      }
    },
    goDetail(item) {
      console.log(item);
      let query = { id: item.declare_id,articleId:item.id, btnType: '1' ,declare_id: item.declare_id}
      clickUrl('/article/detail', query)
      // if(item.declare_id){
      //   query.btnType = '1'
      //   query.declare_id = item.declare_id
      //   clickUrl('/declare/detail', { id: item.id,declare_id:item.declare_id, btnType: '1',matchingDegree: item.matchingDegree ,matchType:1,declare_id: item.declare_id})
      // }else if(item.policy_id){
      //   query.id = item.policy_id
      //   clickUrl('/policy/detail', query)
      // }else{
      //   query.id = item.notify_id
      //   clickUrl('/notify/detail', query)
      // }

      // clickUrl('/detail', query)
    },
    async getdispatchDepartment() {
      let res = await dispatchDepartmentGetAll({type: this.activeTabs})
      this.departmentList = res.result.map(item=>{
        return item.dispatch_name
      }) || []
      // this.searchTpt = this.searchTpt.map(o => {
      //   if (o.name == 'dispatchDepartment') {
      //     o.options = result
      //   }
      //   return o
      // })
    },
    onConfirm(val){
      this.formSearch.dispatchDepartment = val
      this.showPicker = false
    },
    async getDeclareList() {
      let res = await getServiceProviderList({type:'policy_declare_flag'})
      this.declareList = res.result.data ? res.result.data : []
    },
    async getCompany() {
      let res = await queryUserById({ userId: this.userId })
      this.company = res.data ? res.data : {}
    },
    declare(item) {
      this.declareInfo = item
      this.declareShow = true
    },
    declareSelected(arg) {
      console.log(arg)
      this.declareShow = false
      let query = {
        type: 'getPhone',
        declare_id: this.declareInfo.id,
        serviceProviderId: arg.id,
        // companyName: this.company.companyName ? this.company.companyName : '',
        // policyId: this.declareInfo.id,
        // serviceProviderId: arg.id,
        // userId: this.userId,
        // company: JSON.stringify(this.company),
        // phone: this.company.phone ? this.company.phone : "",
      }
      clickUrlToPhone('', query)
    },
    closeDeclare() {
      this.declareShow = false
    },
    getText(str) {
      let words = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, ""); //这里是去除标签
      return words.replace(/\s/g, "") //这里是去除空格
    },


 beforeRouteEnter(to, from, next) {
    store.commit('ADD_KEEP_ALIVE_COM', 'Home');
    next();
  },
  beforeRouteLeave(to, from, next) {
    let coms = ['DeclareDetail','EnterpriseMatch','Setup'];
    console.log(coms.indexOf(to.name) === -1, to.name);
    if (coms.indexOf(to.name) === -1) {
      store.commit('REMOVE_KEEP_ALIVE_COM', 'SearchResult');
    }
    next();
  },
    goto(){
      clickUrl('/policy_query/index')
    },
      goVip() {
          clickUrl('/vip')
      },
      goMore() {
          clickUrl('/enterprise_match')
      },
      async doFav(record, type) {
          console.log(record.id);
      console.log(record.favorite);
            if(this.favFlag){
                return false
            }
            this.favFlag = true
            const request = type ? addFavoritev3 : cancelFavoritev3
            let res = await request({ 'article_id': record.id })
            this.$toast.success({ message: type ? '收藏成功' : '取消收藏成功', duration: 2000 })
            // this.recordtype=!this.recordtype
           setTimeout(() => {
                this.favFlag = false
                record.favorite=!record.favorite
                if( record.favorite){
                  record.favorite_num+=1
                }else{
                   record.favorite_num-=1
                }
                // this.getData()
            }, 2000)
    },
  },
};
</script>
<style lang="scss" scoped>
.notice-new-list-box {
  position: relative;
  padding-top: 60px;
}
.notice-new-title {
  display: flex;
font-size: 14px;
  font-weight: 500;
  color: #000000;
  line-height: 20px;
  margin: 0 6px;
  img {
    height: 10px;
    width: 10px;
  }
}
  .txt-img {
    content: "";
    display: block;
    width: 94%;
    height: 3px !important;
    margin-bottom: 0.25rem;
    margin-left: 3%;
    background-size: cover;
    /* background-image: url(".././../../assets/images/hr@2x.png"); */
  }
.notice-item {
  & {
    margin: 12px 3px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 1px rgba(128, 107, 78, 0.15);
    border-radius: 8px;
  }

  &-title {
    padding: 7px;
    font-weight: 550;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    background: linear-gradient(180deg, #e6f5ff 0%, #cfecff 100%);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .policy-content {
    padding: 5px 7px 0;
  }

  &-tags {
    display: flex;
    flex-wrap: wrap;
  }

  &-tags > * {
    margin-bottom: 8px;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    color: #666;
    font-size: 12px;
    padding: 10px 7px 10px;
  }

  &-footer > flex {
    justify-content: space-between;
  }
}

.level {
  font-size: 12px;
  font-weight: 400;
  padding: 3px;
  background: #1989fa;
  color: #fff;
  border-radius: 4px;
}
.policy-content {
  color: rgba(0, 0, 0, 0.6);
}
.btn-boxs {
  width: 73px;
  height: 30px;
  margin-left: 12px;
  .btn-favorite {
    width: 100%;
    height: 30px;
    line-height: 35px;
    background: #24caa4;
    border: 1px solid transparent;
    color: #fff;
    border-radius: 30px;
    padding: 0 !important;
    text-align: center;
    .icon-favorite {
      height: 15px;
      background-size: cover;
      vertical-align: middle;
      margin-top: -4px;
    }
    &-active {
      background: linear-gradient(90deg, #ff7019 0%, #fe8f1a 100%);
    }
    &-dis{
        background: rgba(85, 138, 126, 0.2);
    }
  }
}
.notice-item-novip {
  filter: blur(4px);
  .notice-item-title{
color: rgba(0, 0, 0, 0.2);
  }
}

.policy-file-item-tags {
  display: flex;
  flex-wrap: wrap;
  // max-width: 80px;
 white-space: nowrap;
 overflow: hidden;
 text-overflow: ellipsis;
}
.tag {
  max-width: 80px;
  padding: 0 3px;
  border-radius: 4px;
  font-weight: 400;
  margin-right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  font-size: 10px;
  -webkit-text-size-adjust: none;

  &.tag_0 {
    background: rgba(216, 244, 240, 0.5);
    border: 1px solid rgba(51, 151, 139, 0.8);
    color: #33978b;
  }

  &.tag_1 {
    background: rgba(139, 184, 213, 0.15);
    border: 1px solid #8bb8d5;
    color: #8bb8d5;
  }
}

.notice-item-content{
    position: relative;
.novip-box{
    position: absolute;
z-index:10;
display: flex;
align-items: center;
text-align: center;
top:0;
left:0;
width:100%;
height: 100%;
font-size: 12px;
color: #666;
.flex-item{
    flex: 1;
    .btn{
    width: 105px;
    height:35px !important;
    line-height: 30px;
    background: linear-gradient(180deg, #FFF4E0 0%, #FBCB89 100%);
    box-shadow: 0px 4px 4px 1px rgba(180, 164, 123, 0.25);
    border-radius: 20px;
    border: 0;
    font-size: 12px;
    font-weight: 600;
    color: #FF5019;
    white-space: nowrap;
    margin-top:5px;

    }
}
}
}

.btn-more-box{
    width: 174px;
    height: 40px;
    margin: 20px auto;
.btn-more{
    width:100%;
    height: 40px !important;
    color: #fff;
    background: #1A8AF1;
    line-height:40px;
    font-size: 14px;
    border-radius: 20px;
    border: 1px solid transparent;
    .img-more{
        height: 11px;
        background-size: cover;
        vertical-align: middle;
        margin-left: 1px;
    }
    }
}
.tabs-box {
  margin-left: 3%;
  width: 94%;
  background-color: #FCD093!important;
  margin-bottom: 15px;
}
.van-tabs__nav{
  background: #EEEEEE !important;
  border-radius: 4px 4px 0px 0px !important;
  opacity: 1;
}
.tabs-box1 {
position: absolute;
top: -45px;
z-index: 100;
width: 100%;
}
.serch {
  text-align: center;
  display: flex;
  /* justify-content: space-evenly; */
  height: 10px;
  margin-bottom: 10px;
  width: 100%;
  font-weight: 500 !important;

}
 .serch-item{
  /* margin-left: 44px; */
  width: 60px;
  height: 15px;
    color: #FEAD66;
    position: relative;
    padding-right: 2px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
/* &:after {
    position: absolute;
    top: 50%;
    right: -4px;
    margin-top: -5px;
    border: 3px solid;
    border-color: transparent transparent currentColor currentColor;
    transform: rotate(-45deg);
    opacity: .8;
    content: "";
} */

&-active:after {
    margin-top: -1px;
    transform: rotate(135deg);
}
  }
  .field-ul {
      margin: 0 20px;
      display: flex;
      flex-wrap: wrap;
      /* white-space: pre-wrap; */
  }
  .flex-tag-select-container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        box-sizing: border-box;
        z-index: 10;
        /* overflow: auto; */
    }
    .title {
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 16px;
      text-align: center;
      background-color: #F2F2F2;
      margin-top: 0px;
      padding-top:10px !important;
      height: 30px;
      line-height: 30px;
    }
     .flex-tag-select-item {
      display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        min-height:30px;
        border: 1px solid #fff;
        box-sizing: border-box;
        background: rgba(231, 231, 231, 0.4);
        border-radius: 4px;
    }
    .flex-tag-select-item.selected {
        border: 1px solid #1989FA;
        color: #fff;
        background: #1989FA;
    }
    .roundbtn{
      height: 40px !important;
      background-color: #02A7F0;
      color: #fff;
      width: 100%;
    }

    .match-container-search {
      position: relative;
      width: 90%;
      margin-left:5%;
      height: 30px;
      color: rgba(254, 129, 25, 0.6);
      background: #FFF9F1 100%;
      border-radius: 26px 26px 26px 26px;
      opacity: 1;
      border: 1px solid rgba(254, 129, 25, 0.5);

    input {
      flex: 1;
      height: 30px;
      border-radius: 26px;
      border: 0;
      padding: 0  10px;
      // border-right: 2px solid #ededed;
      box-sizing: border-box;
      font-size: 12px;
      // background: #d7f0ff;
      background: #fef0db;
      color: #FE8119 50%;
      &::placeholder {
        color: rgba(254, 129, 25, 0.6);
      }
    }

    .btn {
      position: absolute;
      right:2px ;
      top: 2px;
      /* margin-right: 2px; */
      /* margin-top:2px; */
      width: 70px;
      height: 25px;
      background: #FE8119;
      border-radius: 26px;
      /* border: 1px solid rgba(255, 255, 255, 0.8); */
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      /* margin: auto 3px auto 7px; */

      img {
        width: 12px;
        background-size: contain;
      }
    }

    .detail {
      width: 100%;
      position: absolute;
      top: 46px;
      left: 0px;
      z-index: 999;
    }
  }
  .fack {
   border-bottom: 1px solid;
   padding-bottom: 4px;
border-image: linear-gradient(90deg, rgba(254, 132, 30, 0), rgba(254, 132, 30, 0.24), rgba(254, 132, 30, 0.26), rgba(254, 132, 30, 0)) 1 1;
    width: 100%;
    position: absolute;
    top: -85px;
    z-index: 500;
    /* background: #fff; */
  }

  ::v-deep .van-tabs__nav {
  background: #e7e7e7;
  border-radius: 8px;
  .van-tab {
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.4);
    line-height: 16px;
    &--active {
      background: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .van-tab__text {
        color: rgba(0, 0, 0, 0.8) !important;
      }
    }
  }
}
::v-deep .tab_1 {
      color: #000;
     font-weight: 500;
}
::v-deep .van-tabs__wrap {
  height: 34px !important;
}
::v-deep .van-tabs__line{
  display: none;
}
.serch-text {
  font-size: 12px;
font-family: PingFang SC-Regular, PingFang SC;
font-weight: 400;
color: #B3B3B3;
line-height: 14px;
  width: 40px;
}
.show5btn {
 width: 220px;
height: 40px !important;
background: #1777FF;
border-radius: 20px 20px 20px 20px;
opacity: 1;
margin-top: 30px;
}
.box-title {
  background: #219FF7;
  font-size: 16px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 19px;
}
</style>
